import React from "react";
import {IListViewField} from "src/components/Shared/ILIstViewField";
import {AppEntities} from "src/config/entities";
import {ReturnOfGoodsFromVendorsService} from "src/services/documents/ReturnOfGoodsFromVendorsService";
import {PaymentRequestsService} from "src/services/documents/PaymentRequestsService";
import {DistributionOfLandedCostsService} from "src/services/documents/DistributionOfLandedCostsService";
import {IListViewCreateDependedDocumentAction} from "src/components/Shared/IListViewCreateDependedDocumentAction";
import {ListView} from "src/components/Shared/ListViews/ListView";
import {DocumentListViewToolbar} from "src/components/Shared/ListViews/DocumentListViewToolbar";
import {
  DocumentListViewDefaultToolbarButtons
} from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import {ListviewToolbarSubmenuButton} from "src/components/Shared/ListViews/ListviewToolbarSubmenuButton";
import {ListviewToolbarMoreActions} from "src/components/Shared/ListViews/ListviewToolbarMoreActions";

const VendorInvoicesList = () => {
  const fields: IListViewField[] = [
    {
      fieldName: "companyName",
      title: "Company",
      fieldType: "string"
    },
    {
      fieldName: "vendorName",
      title: "Vendor",
      fieldType: "string"
    },
    {
      fieldName: "warehouseName",
      title: "Warehouse",
      fieldType: "string"
    },
    {
      fieldName: "currencyName",
      title: "Currency",
      fieldType: "string"
    },
    {
      fieldName: "totalAmount",
      title: "Total Amount",
      fieldType: "number"
    },
    {
      fieldName: "totalAmountVat",
      title: "Total Amount Vat",
      fieldType: "number"
    }
  ];

  const createReturnGoodsFromVendorInvoice = async (data: any) => {
    try {
      const dataService = AppEntities.ReturnOfGoodsFromVendors.getDataService() as ReturnOfGoodsFromVendorsService;
      return await dataService.createBasedAtVendorInvoice(data.id);
    } catch (err) {
      console.log("data", data);
      console.log("error with", err);
    }
  };

  const createPaymentRequestFromVendorInvoice = async (data: any) => {
    try {
      const dataService = AppEntities.PaymentRequests.getDataService() as PaymentRequestsService;
      return await dataService.createBasedAtVendorInvoice(data.id);
    } catch (err) {
      console.log("data", data);
      console.log("error with", err);
    }
  };

  const createDistributionOfLandedCostFromVendorInvoice = async (data: any) => {
    console.log("createDistributionOfLandedCostFromVendorInvoice", data);
    try {
      const dataService = AppEntities.DistributionOfLandedCosts.getDataService() as DistributionOfLandedCostsService;
      return await dataService.createBasedAtVendorInvoice(data.id);
    } catch (err) {
      console.log("data", data);
      console.log("error with", err);
    }
  };

  const createDocumentActions: IListViewCreateDependedDocumentAction[] = [
    {
      title: "Payment Request",
      appEntity: AppEntities.PaymentRequests,
      createBaseAtFunction: createPaymentRequestFromVendorInvoice
    },
    {
      title: "Distribution Of Landed Costs",
      appEntity: AppEntities.DistributionOfLandedCosts,
      createBaseAtFunction: createDistributionOfLandedCostFromVendorInvoice
    },
    {
      title: "Return Of Goods From Vendor",
      appEntity: AppEntities.ReturnOfGoodsFromVendors,
      createBaseAtFunction: createReturnGoodsFromVendorInvoice
    }
  ];

  return (
    <>
      <ListView
        createDocumentActions={createDocumentActions}
        fields={fields}
        entity={AppEntities.VendorInvoices}
        createDependedDocumentActions={createDocumentActions}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons>
            <ListviewToolbarSubmenuButton />
          </DocumentListViewDefaultToolbarButtons>
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};
export default VendorInvoicesList;
